
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"

export default defineComponent({
  setup() {
    const store = useStore()

    onMounted(() => {
      setCurrentPageBreadcrumbs("吃菜/做菜排名", ["抽赏中心"])
    })

    const activeTab = ref("eat")
    const tableData = ref<any[]>([])

    const formData = ref({ mobile: '', from: '', to: '' })

    const page = ref({ currentPage: 1, pageSize: 20, totalResult: 0 })

    const query = () => {
      const params: Record<string, unknown> = {
        pool_type: activeTab.value,
        ...page.value
      }
      if (formData.value.mobile) params.mobile = formData.value.mobile
      if (formData.value.from) params.from = formData.value.from
      if (formData.value.to) params.to = formData.value.to

      store
        .dispatch(Actions.GET_PRODUCT_GIFT_RECORD_RANKING, params)
        .then(() => {
          tableData.value = store.getters.currentRankingList
          page.value.totalResult = store.getters.currentRankingCount
        })
        .catch(() => { ElMessage.error('获取排名失败') })
    }

    query()

    const submitEvent = () => { page.value.currentPage = 1; query() }
    const onTabChange = () => { page.value.currentPage = 1; query() }
    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }
    const onReset = () => {
      formData.value = { mobile: '', from: '', to: '' }
      page.value.currentPage = 1
      query()
    }

    return { activeTab, tableData, formData, page, submitEvent, onTabChange, onPageChange, onReset }
  },
})
